// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { connect } from 'react-redux'
import { Select, Cascader } from 'antd'
import './index.less'
import { EnvironmentOutlined } from '@ant-design/icons'
import { ICity } from '../../models/city'



export const buildCascaderData = (originOptions: ICity[]) => {
  const result = []
  const continent = {}
  const country = {}

  originOptions.forEach((item : any) => {
    const cityOption = {value: item.id, label: item.name}
    if(country[item.country]){
      country[item.country].push(cityOption)
    }else{
      country[item.country] = [cityOption]
    }
    const countryOption = {
      value: item.country,
      label: item.country,
      children: country[item.country]
    }
    if(continent[item.continent]){
      const targetCountry = continent[item.continent].find(one => one.value === item.country)
      if(!targetCountry){
        continent[item.continent].push (countryOption)
      }
    }else {
      continent[item.continent] = [countryOption]
    }
    const continentOption = {
      value: item.continent,
      label: item.continent,
      children: continent[item.continent]
    }
    const targetContinent = result.find(one => one.value === item.continent)
    if(!targetContinent){
      result.push(continentOption)
    }
  })
  return result
}

const Option = Select.Option

export interface ICityFilterProps {
  onCityChange: (cityId) => void
  cityList: ICity[]
  current: any
  disabled: boolean
}
export interface ICityFilterState {

}

export function filter(inputValue, path) {
  return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
}
class CityFilter extends React.Component<ICityFilterProps, ICityFilterState> {
  async handleCityChange (value) {
    const lastIndex = value.length > 0 ? value.length - 1 : 0
    const cityId = value[lastIndex]
    const { onCityChange } = this.props
    await onCityChange(cityId)
  }


  render () {
    const { cityList, current, disabled } = this.props
    const options = buildCascaderData(cityList)
    return (
      <div className='city-filter'>
        <EnvironmentOutlined style={{ marginRight: 12 }} />
        <Cascader
          onChange={this.handleCityChange.bind(this)}
          allowClear={false}
          showSearch={{filter}}
          value={[current?.continent,current?.country,current?.id]}
          displayRender={(values)=> values[values.length > 0 ? values.length -1 : 0 ]}
          expandTrigger={'hover'}
          size='small'
          disabled={disabled}
          options={options}
        />
      </div>
    )
  }
}

export default connect(
  ({ city }) => ({ ...city }),
  ({ city }) => ({ ...city })
)(CityFilter)
